import axios from 'axios';
import { Dialog } from 'quasar';
import { useAuthStore } from '../stores/auth-store';
import Token from '../types/auth/token';

const tokenService = {
  setAuthClientToken() {
    return new Promise((resolve, reject) => {
      axios.get(process.env.DealersApiUrl! + '/auth/client/token').then((response) => {
        resolve((response.data as Token).authenticationToken);
      }).catch((error) => {
        reject(error);
      });
    });
  },
  checkDealerToken(): Promise<string> {
    return new Promise((resolve, reject) => {
      this.authenticate().then((token: Token) => {
        resolve(token.authenticationToken);
      }).catch((error) => {
        reject(error);
      })
    })
  },
  async authenticate(): Promise<Token> {
    return new Promise((resolve, reject) => {

      const authStore = useAuthStore();
      const dealerToken = authStore.token;

      if (dealerToken !== null) {

        if (authStore.user.exp < Date.now() / 1000) {

          Dialog.create({
            title: "Security warning",
            message: "It has been a while since you've logged in. For security reasons you must continue to log in.",
            persistent: true
          }).onOk(() => {
            useAuthStore().logout(true);
          })

          reject({ response: { status: 401 } });
        }
        else {
          resolve(dealerToken);
        }
      }
      else {
        reject({ response: { status: 401 } });
      }
    })
  }
};

export default tokenService;
